import type { ParentProps } from "solid-js";
import { Show } from "solid-js";
import { Button } from "~/common/button";
import twelveLogoWithText from "@assets/images/twelve-logo-with-text.svg?url";

type Props = ParentProps<{
  showTwelveLogo?: boolean;
}>;

export function PrintLayout(props: Props) {
  return (
    <div class="mx-auto max-w-[950px] p-6">
      <div class="mb-6 flex items-center justify-between">
        <Show when={props.showTwelveLogo}>
          <img src={twelveLogoWithText} alt="Twelve logo" class="h-8" />
        </Show>
        <Button variant="primary" class="ml-auto print:hidden" onClick={() => window.print()}>
          Print
        </Button>
      </div>
      {props.children}
    </div>
  );
}
